// (function () {
//     'use strict';

//     let module = angular.module('imApp');

//     module.component('factsedit', {
//         templateUrl: 'views/components/views/factsedit/factsedit.template.html?v=' + module.version,
//         controllerAs: 'vm',
//         controller: ['$stateParams', 'stateService', 'modalService', 'translateService', 'factsEditService', function ($stateParams, stateService, modalService, translateService, factsEditService) {

//             // #region VARIABLES & DEFINITIONS

//             let vm = this;
//             let factsId = $stateParams.facts_id;

//             let translations = {
//             	error: '',
//                 ok: '',
//                 confirm_title: '',
//                 confirm_message: '',
//                 confirm_ok_label: '',
//                 confirm_cancel_label: ''
//             };

//             vm.model = {
//                 edit: {},
//                 selectListValueTypes: [],
//                 lockedSave: false,
//                 lockedDelete: false
//             };

//             // #endregion VARIABLES & DEFINITIONS

//             // #region TRANSLATE SERVICE

//             translateService.translateBatch(translations).then(function (data) {
//             	angular.forEach(translations, function (_, key) {
//             		if (angular.isDefined(data[key])) {
//             			translations[key] = data[key];
//             		}
//             	});
//             });

//             // #endregion TRANSLATE SERVICE

//             // #region LOAD PROCEDURE FUNCTION CALLS

//             let loadEdit = function () {
//             	factsEditService.getFactsEdit({ facts_id: factsId }).then(function (result) {
//             		angular.copy(result[0], vm.model.edit);
//             	});
//             };

//             let loadValueTypes = function () {
//                 factsEditService.listValueTypes().then(function (result) {
//                     angular.copy(result, vm.model.selectListValueTypes);
//                 });
//             };

//             // #endregion LOAD PROCEDURE FUNCTION CALLS

//             // #region BUTTON SAVE PROCEDURE FUNCTION CALL

//             vm.saveChanges = function () {
//                 vm.model.lockedSave = true;

//                 factsEditService.saveObj(vm.model.edit).then(function (response) {
//                     if (response[0].errorcode !== '0') {
//                     	modalService.show({
//                     		type: 'warning',
//                     		title: translations.error,
//                     		message: response[0].errormessage,
//                     		buttons: [{
//                     			label: translations.ok,
//                     			cssClass: 'btn-warning',
//                     			action: function (dialogItself) {
//                     				dialogItself.close();
//                     				vm.model.lockedSave = false;
//                     			}
//                     		}]
//                     	});
//                     } else {
//                     	vm.model.lockedSave = false;
//                     	stateService.back();
//                     }
//                 });
//             };

// 		    // #endregion BUTTON SAVE PROCEDURE FUNCTION CALL

//             // #region BUTTON DELETE PROCEDURE FUNCTION CALL

//             vm.deleteValues = function () {
//                 vm.model.lockedDelete = true;

//                 modalService.confirm({
//                     type: 'danger',
//                     title: translations.confirm_title,
//                     message: translations.confirm_message,
//                     okLabel: translations.confirm_ok_label,
//                     cancelLabel: translations.confirm_cancel_label
//                 }).then(function () {
//                     factsEditService.deleteItem(vm.model.edit).then(function (response) {
//                         if (response[0].errorcode !== '0') {
//                             modalService.show({
//                                 type: 'warning',
//                                 title: translations.error,
//                                 message: response[0].errormessage,
//                                 buttons: [{
//                                     label: translations.ok,
//                                     cssClass: 'btn-warning',
//                                     action: function (dialogItself) {
//                                         dialogItself.close();
//                                         vm.model.lockedDelete = false;
//                                     }
//                                 }]
//                             });
//                         } else {
//                             vm.model.lockedDelete = false;
//                             stateService.back();
//                         }
//                     }, function () {
//                 	    vm.model.lockedDelete = false;
//                     });
//                 }, function () {
//                     vm.model.lockedDelete = false;
//                 });
//             };

// 		    // #endregion BUTTON DELETE PROCEDURE FUNCTION CALL

//             // #region ON INIT FUNCTION

//             vm.$onInit = function () {
//                 loadEdit();
//                 loadValueTypes();
//             };

//             // #endregion ON INIT FUNCTION
//         }]
//     });
// })();
